import { render } from "./Consulta.vue?vue&type=template&id=dde1ef7e"
import script from "./Consulta.vue?vue&type=script&lang=js"
export * from "./Consulta.vue?vue&type=script&lang=js"

import "./Consulta.vue?vue&type=style&index=0&id=dde1ef7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__